(() => {
  const modalSelector = '.ma-make-an-offer-modal';
  const contrastAttribute = 'data-mh-offer-contrast';
  let frameId;

  const parseRgb = (value) => {
    const match = value.match(
      /rgba?\(\s*([\d.]+)(?:\s*,\s*|\s+)([\d.]+)(?:\s*,\s*|\s+)([\d.]+)(?:(?:\s*,\s*|\s*\/\s*)([\d.]+))?\s*\)/i
    );

    if (!match) return null;

    return {
      red: Number(match[1]),
      green: Number(match[2]),
      blue: Number(match[3]),
      alpha: match[4] === undefined ? 1 : Number(match[4]),
    };
  };

  const channelLuminance = (channel) => {
    const value = channel / 255;
    return value <= 0.04045
      ? value / 12.92
      : Math.pow((value + 0.055) / 1.055, 2.4);
  };

  const luminance = (color) =>
    0.2126 * channelLuminance(color.red) +
    0.7152 * channelLuminance(color.green) +
    0.0722 * channelLuminance(color.blue);

  const contrastRatio = (first, second) => {
    const light = Math.max(first, second);
    const dark = Math.min(first, second);
    return (light + 0.05) / (dark + 0.05);
  };

  const repairContrast = () => {
    document.querySelectorAll(`${modalSelector} *`).forEach((element) => {
      if (element.matches('img, svg, path, use')) return;

      const isField = element.matches('input, textarea, select');
      if (!isField && !element.textContent.trim()) return;

      const styles = getComputedStyle(element);
      const background = parseRgb(styles.backgroundColor);
      const foreground = parseRgb(styles.color);

      if (!background || !foreground || background.alpha < 0.85) {
        element.removeAttribute(contrastAttribute);
        return;
      }

      const backgroundLuminance = luminance(background);
      const foregroundLuminance = luminance(foreground);
      const isRepaired = element.hasAttribute(contrastAttribute);
      const needsDarkText =
        backgroundLuminance > 0.65 &&
        (isRepaired || contrastRatio(backgroundLuminance, foregroundLuminance) < 4.5);

      if (needsDarkText) {
        element.setAttribute(contrastAttribute, 'dark');
      } else {
        element.removeAttribute(contrastAttribute);
      }
    });
  };

  const scheduleRepair = () => {
    cancelAnimationFrame(frameId);
    frameId = requestAnimationFrame(repairContrast);
  };

  const start = () => {
    const observer = new MutationObserver(scheduleRepair);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'open'],
    });

    document.addEventListener('focusin', scheduleRepair, true);
    document.addEventListener('input', scheduleRepair, true);
    document.addEventListener('change', scheduleRepair, true);
    scheduleRepair();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
